import * as TYPES from './patient-actiontypes';

export const loadPatientAddress = (address) => (
  {
    type: TYPES.LOAD_PATIENT_ADDRESS_SUCCESS,
    address,
  }
);
